import { getRangeLabel } from "../../components/discoveryRangeFilters.shared";
import { H6 } from "@sellar-io/components";
import { useMediaQuery } from "usehooks-ts";
import { useShallow } from "zustand/react/shallow";

import { DiscoveryFilterButton } from "../components/DiscoveryFilterButton";
import { FilterDrawerHeader } from "../components/DiscoveryMobileFilterDrawer";
import {
  abvFilterType,
  AbvType,
  useDiscoveryV2SearchStore,
} from "../DiscoveryV2SearchStore";
import { CollapsableFilterCard } from "./FilterCard";

export const FilterAbvCard = ({ onClick }: { onClick?: () => void }) => {
  const isDesktop = useMediaQuery("(min-width: 1084px)");
  const { selectedAbvTypes, removeAbvType, addAbvType, abvRange, setAbvRange } =
    useDiscoveryV2SearchStore(
      useShallow((state) => ({
        selectedAbvTypes: state.selectedAbvTypes,
        abvRange: state.abvRange,
        setAbvRange: state.setAbvRange,
        addAbvType: state.addAbvType,
        removeAbvType: state.removeAbvType,
      })),
    );

  const onItemClick = (abvTypeKey: AbvType) => {
    if (selectedAbvTypes.includes(abvTypeKey)) {
      return removeAbvType(abvTypeKey);
    }
    addAbvType(abvTypeKey as AbvType);
  };
  const rangeControl = abvRange ? (
    <button
      type="button"
      aria-label="Clear ABV range"
      onClick={() => setAbvRange(undefined)}
      className="flex w-fit items-center gap-2 rounded-md border border-zinc-300 bg-zinc-200 px-3 py-2 text-sm focus-visible:outline-2 focus-visible:outline-purple-600"
    >
      {getRangeLabel(abvRange, (value) => `${value}%`)}{" "}
      <span aria-hidden="true">×</span>
    </button>
  ) : null;
  return (
    <>
      {isDesktop ? (
        <CollapsableFilterCard header={<H6>ABV</H6>}>
          {rangeControl}
          {Object.keys(abvFilterType).map((abvTypeKey) => (
            <DiscoveryFilterButton
              key={abvTypeKey}
              selected={selectedAbvTypes.includes(abvTypeKey)}
              onClick={() => onItemClick(abvTypeKey as AbvType)}
              title={abvFilterType[abvTypeKey as AbvType].name}
            />
          ))}
        </CollapsableFilterCard>
      ) : (
        <div className={"flex flex-col"}>
          <FilterDrawerHeader title={"ABV"} onClick={onClick} />
          <div className={"mt-4 flex flex-col gap-1 p-4"}>
            {rangeControl}
            {Object.keys(abvFilterType).map((abvTypeKey) => (
              <DiscoveryFilterButton
                key={abvTypeKey}
                selected={selectedAbvTypes.includes(abvTypeKey)}
                title={abvFilterType[abvTypeKey as AbvType].name}
                onClick={() => onItemClick(abvTypeKey as AbvType)}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};
